import React from "react";
import { Button } from '@mui/material';

const filterConfig = (Translation: any, onSearch: any, onReset: any, optsData: any, locale:string) => {
    return [
        [
            { type: 'header', label: Translation('title.mandatory.training.collection.filter'), sm: true },
            {
                type: 'custom',
                sm: false,
                render: () =>
                    <Button variant="contained" color="inherit"  onClick={onReset}>
                        {Translation('golbal.filters.reset')}
                    </Button>
            },
            {
                type: 'custom',
                sm: false,
                render: () =>
                    <Button variant="contained" color="secondary" onClick={onSearch} >
                        {Translation('golbal.filters.search')}
                    </Button>
            },
        ],
        [
            { type: 'input', label: Translation('component.formLabel.name'), prop: 'name', width: 300 },
            { type: 'select', label: Translation('event.list.detail.category'), prop: 'categoryId', opts: Object.entries(optsData.categoriesData).map(([key, value]: any) => { return {label: value?.[locale]?.name, value: key }}), width: 300 },
            {
                type: 'select', label: Translation('component.formLabel.publish-status'), prop: 'publishStatus', opts: [
                    { label: 'All', value: '' },
                    { label: Translation('event.publish.status.Draft.label'), value: '0' },
                    { label: Translation('event.publish.status.Published.label'), value: '1' },
                    { label: Translation('event.publish.status.Unpublished.label'), value: '2' },
                    { label: Translation('event.publish.status.WaitingForPublish.label'), value: '3' },
                ],
            },
            { type: 'dateRange', label: Translation('component.formLabel.last-updated-time'), prop: 'timeRange', format: "DD/MM/YYYY HH:mm:ss", width: 500 },
            { type: 'input', label: Translation('component.formLabel.last-updated-by'), prop: 'modifier', width: 300 },
        ],
    ];
};

export default filterConfig;